export default __webpack_public_path__ + "static/media/roomTwo.f22ecaa1.jpg";